import styled from "styled-components";

export const DealerSearchContainer = styled.div`
  display: flex;
  flex-flow: column wrap;
`;
